import type { MeMenuItem } from '../api/services/me.service'

/**
 * Entradas de menú que todavía NO existen en la tabla `MenuItem`.
 *
 * "Directorio de Comercializadores" es un mock para la demo del producto
 * Kuntur Comercializadores (comercializador.kuntur.com.pe): muestra cómo se
 * conectan ambos sistemas sin backend detrás. Cuando el módulo sea real, se
 * siembra en `MenuItem` (con su permiso) y se borra este archivo.
 *
 * Hereda `allowed` del Directorio de Mineros: quien ve a los mineros ve a los
 * comercializadores.
 */
export function withMockMenuItems(menu: MeMenuItem[]): MeMenuItem[] {
  return menu.map(section => inject(section))
}

function inject(item: MeMenuItem): MeMenuItem {
  if (item.code === 'identity.directory') {
    const miners = item.children.find(c => c.code === 'identity.directory.miners')
    if (!miners || item.children.some(c => c.code === 'identity.directory.traders')) return item
    const traders: MeMenuItem = {
      ...miners,
      id: 'mock-identity-directory-traders',
      code: 'identity.directory.traders',
      label: 'i18n:identity.directory.traders',
      route: '/app/comercializadores',
      order: miners.order + 1,
      children: [],
    }
    const idx = item.children.indexOf(miners)
    const children = [...item.children]
    children.splice(idx + 1, 0, traders)
    return { ...item, children }
  }
  return item.children?.length ? { ...item, children: item.children.map(inject) } : item
}
